/* Extracted 2026-10-13 from sections/announcement-bar.liquid block 11 (auto benefit pills; product pages only, as before). Guards on DOMContentLoaded, so defer is safe. SEO round 3, audit C1. */
(function() {
      /* ── Auto-extract benefit pills from description bullets ── */
      function initAutoExtract() {
        var container = document.querySelector('[data-tlc-auto-benefits]');
        if (!container) return;

        /* Find description element — try common Shopify class names */
        var descEl = document.querySelector(
          '.product__description, .tlc-story-prose, [class*="product-description"], .description'
        );
        if (!descEl) return;

        var bullets = descEl.querySelectorAll('li');
        var pills = [];
        var skipPatterns = [
          'patch test', 'keep away', 'avoid', 'consult', 'do not',
          'store in', 'for external', 'discontinue', 'children',
          'directions', 'how to use', 'ingredients', 'country of origin'
        ];

        bullets.forEach(function(li) {
          var text = li.textContent.trim();
          /* Length guard: too short = fragment, too long = a how-to-use step */
          if (text.length < 8 || text.length > 75) return;
          var lc = text.toLowerCase();
          if (skipPatterns.some(function(p) { return lc.indexOf(p) !== -1; })) return;
          pills.push(text);
        });

        /* Cap at 3 benefit pills */
        pills = pills.slice(0, 3);

        if (pills.length > 0) {
          pills.forEach(function(pill) {
            var span = document.createElement('span');
            span.className = 'tlc-benefit-pill';
            span.textContent = pill;
            container.appendChild(span);
          });
          container.style.display = '';
        }
        /* If still empty after JS, container stays hidden — no orphan row */
      }

      function initSocialProof() {
        /* ── Viewer count: 1,000 – 10,000, seeded per product URL ── */
        var viewerEl = document.getElementById('tlc-viewer-count');
        if (viewerEl) {
          var pathHash = window.location.pathname.split('').reduce(function(a, c) {
            return a + c.charCodeAt(0);
          }, 0);
          /* Map hash → 500–800 range */
          var viewSeed = 500 + (pathHash % 301);
          function fmtViews(n) { return String(n); }
          viewerEl.textContent = fmtViews(viewSeed);
          /* Drift ±1–5 every 3 seconds, live on page */
          setInterval(function() {
            viewSeed = viewSeed + (Math.random() > 0.5 ? 1 : -1) * (Math.floor(Math.random() * 5) + 1);
            viewSeed = Math.max(500, Math.min(viewSeed, 800));
            viewerEl.textContent = fmtViews(viewSeed);
          }, 3000);
        }

        /* ── Loved by: cumulative customer count, same seed logic ── */
        var lovedEl = document.getElementById('tlc-loved-count');
        if (lovedEl) {
          /* Global store number — feels like total customers, not per-product */
          lovedEl.textContent = '1 Lakh+';
        }
      }
      function initAll() {
        initAutoExtract();
        initSocialProof();
      }
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initAll);
      } else {
        initAll();
      }
    }());
